module.exports = __webpack_public_path__ + "img/logo_brand.c8182aab.png";